import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";

export function useGetSchedulingAvailability(programId: number) {
  return useQuery({
    queryKey: ["get-scheduling-availability", programId],
    queryFn: async () => {
      return await apiRequest(
        `/scheduling/availability/${programId}/`,
        "GET"
      );
    },
    select: (data) => {
      return data.time_slots;
    },
    enabled: !!programId,
    retry: false,
  });
}

export default useGetSchedulingAvailability;

